export const encontrarIdAgendamentoCorrespondente = (
  array: any[],
  referencia: any,
): string | null => {
  const formatarData = (data: string): string => {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  const formatarValor = (valor: string): number => {
    const apenasNumero = valor.replace(/[^\d,.-]+/g, '').replace(',', '.');
    return parseFloat(apenasNumero);
  };

  const dataFormatada = formatarData(referencia.dta_vencimento);
  const valorReferencia = referencia.val_parcela;

  const encontrado = array.find((item) => {
    const valorParcela = formatarValor(item.val_parcela);
    return (
      item.cod_finalizadora === referencia.cod_finalizadora &&
      item.dta_vencimento === dataFormatada &&
      valorParcela === valorReferencia
    );
  });

  return encontrado ? encontrado.id : null;
};
